export const salesExecutive = {
  id: 'sales-executive',
  version: 2,
  renderer: 'enterprise',
  name: 'Sales Executive leader',
  layout: 'single-column',
  theme: 'classic-navy',
  density: 'compact',
  persona: ['consulting'],
  atsLevel: 'A',
  scoreWeights: {
    ats: 40,
    visual: 20,
    executive: 30,
    student: 10
  },
  metadata: {
    industry: ['Tech Sales', 'Enterprise SaaS', 'B2B Sales'],
    companies: ['Salesforce', 'Zoom', 'HubSpot', 'Oracle', 'ADP', 'LinkedIn Sales Solutions'],
    ats: ['Workday', 'Taleo', 'Lever', 'Greenhouse'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: false,
    icons: false,
    columns: 1,
    experienceLevel: ['Mid-level', 'Senior', 'Executive'],
    careerStage: 'Professional',
    recommendedFor: ['Account Executives', 'Sales Managers', 'Enterprise Sales Directors', 'Business Development Reps'],
    avoidFor: ['Academic CVs', 'Creative Directors', 'Frontend Developers'],
    dna: ['Sales-Focused', 'ATS-Scannable', 'Quota-Driven', 'Inter-Sans', 'Navy-Professional'],
    metrics: {
      readingDifficulty: 96,
      scanningSpeed: 96,
      visualAppeal: 85
    },
    hiringManager: {
      firstImpression: "High-energy, quota-crushing B2B sales leader with structured presentation",
      scanningStyle: "Linear scanning focusing on sales numbers, quota percentages, territory size, and deal cycles",
      preferredStructure: "Summary, experience, education, skills",
      dislikes: ["Objective statements", "Soft skills self-ratings", "No mention of sales targets or revenue figures"]
    },
    strategy: {
      goal: "Pass enterprise ATS checks and immediately highlight quota achievements and business revenue growth",
      focus: "Sales quotas (e.g. '120% quota attainment'), deal closure figures, and account management scale",
      avoid: ["Gimmicky design tokens", "Secondary columns"]
    },
    psychology: {
      coreTraits: ["Drive", "Authority", "Diligence", "Sales acumen"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: false,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Start bullet points with strong commercial verbs (e.g. 'closed', 'negotiated', 'grew'). Highlight exact sales metrics (e.g. 'achieved 115% of annual quota', 'managed a $2M territory pipeline').",
      rewriteStyle: "Persuasive, result-driven, sales-focused"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: true,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'experience', 'education', 'skills']
      },
      overrides: {
        '--font-family-primary': '"Inter", sans-serif',
        '--spacing-margin': '24px'
      }
    }
  },
  sectionOrder: ['personal-info', 'summary', 'experience', 'education', 'skills'],
  components: {
    header: 'personal-info',
    main: ['summary', 'experience', 'education', 'skills'],
  },
  capabilities: {
    photo: false,
    icons: false,
    multiColumn: false,
    colorAccent: false,
    atsOptimized: true,
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'uppercase',
    '--heading-letter-spacing': '0.06em',
    '--heading-weight': '700',
    '--border-thickness-heading': '2px',
    '--bullet-style': 'disc',
    '--spacing-section-mb': '22px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px'
  }
};
export default salesExecutive;
